// extracted by mini-css-extract-plugin
export default {"nutrientTable":"Q8d1MrgR3y6yC8JnjJ31"};